module.exports = __webpack_public_path__ + "img/banner-resolve.6a9fe0e7.png";